import { Popover, Input, Button, Flex } from "antd";
import React, { useState } from "react";

type TextEditorProps = {
  title: string;
  icon?: React.ReactNode;
  onClick: (value: string) => void;
};

const TextEditor: React.FC<TextEditorProps> = ({ title, icon, onClick }) => {
  const [visible, setVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleIconClick = () => {
    setVisible(!visible);
  };

  const handleOk = () => {
    if (inputValue && onClick) {
      onClick(inputValue+"px");
    }
    setVisible(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const content = (
    <div>
      <Input
        placeholder={`Enter value for ${title}`}
        value={inputValue}
        // type="number"
        onChange={handleInputChange}
        onPressEnter={handleOk}
      />
      <Button type="primary" onClick={handleOk} style={{ marginTop: "8px" }}>
        OK
      </Button>
    </div>
  );

  return (
    <Popover
      content={content}
      title={`Enter value for ${title}`}
      open={visible}
      trigger="click"
      onOpenChange={(visible) => setVisible(visible)}
    >
      <Flex style={{ cursor: "pointer" }} onClick={handleIconClick}>
        {icon}{" "}
      </Flex>
    </Popover>
  );
};
export default TextEditor;
